import React, { useState } from "react";
import "./QuickMenuCard.css";
import nonVegIcon from "../../../../../../assets/images/non-veg-new.png";
import vegIcon from "../../../../../../assets/images/veg-new.png";
import PosCustomIcon from "../../../../../../customComponents/PosCustomIcon/PosCustomIcon";
import { PosCustomButton } from "../../../../../../customComponents/PosCustomButton/PosCustomButton";
import { PencilSquareIcon } from "@heroicons/react/20/solid";
import { EllipsisVerticalIcon } from "@heroicons/react/24/solid";
import { productStatusToggle } from "../../../../../../config/Services";
import { useSnackbar } from "../../../hooks/SnackbarProvider";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import { getStoreCurrencySymbol } from "../../../../../../utils/currency";

const QuickMenuCard = ({
  id,
  image,
  title,
  price,
  shortCode,
  foodType,
  status,
  noInward,
  onEdit,
  onStatusToggle,
}) => {
  const [isEnabled, setIsEnabled] = useState(status === "CREATED" || status === "ACTIVE");
  const [showDropdown, setShowDropdown] = useState(false);
  const [showDisableModal, setShowDisableModal] = useState(false);

  const showSnackbar = useSnackbar();

  const locId = localStorage.getItem("locId");
  const retailType = localStorage.getItem("retailType");
  const userDetails = JSON.parse(localStorage.getItem("retailUserDetails")) || {};

  const callToggleApi = (updatedStatus) => {
    const payload = {
      activate: updatedStatus,
      id: id,
      locationId: locId,
      sourceType: retailType,
      updatedBy: userDetails?.uidx,
      updatedByName: userDetails?.firstName,
    };

    productStatusToggle(payload)
      .then((res) => {
        if (
          res?.data?.es > 0 ||
          res?.data?.data?.es > 0 ||
          res?.data?.status === "ERROR" ||
          res?.data?.data?.status === "ERROR"
        ) {
          const message = updatedStatus
            ? "Unable to enable the product"
            : "Unable to disable the product";
          showSnackbar(message, "error");
          return;
        }
        const message = updatedStatus
          ? "Product enabled successfully"
          : "Product disabled successfully";
        showSnackbar(message, "success");
        setIsEnabled(updatedStatus);
        onStatusToggle?.();
      })
      .catch((err) => {
        const message = updatedStatus
          ? "Unable to enable the product"
          : "Unable to disable the product";
        showSnackbar(message, "error");
      });
  };

  const handleToggle = () => {
    if (isEnabled) {
      setShowDropdown(false);
      setShowDisableModal(true);
    } else {
      callToggleApi(true);
    }
  };

  const handleConfirmDisable = () => {
    setShowDisableModal(false);
    callToggleApi(false);
  };

  return (
    <div className="quickMenuCardContainer">
      <div className="cardMenuImage">
        <img src={image} alt="image" />
        <div className={`statusChip ${isEnabled ? "statusChipActive" : "statusChipInactive"}`}>
          {isEnabled ? "Active" : "In Active"}
        </div>
        {noInward && (
          <div className="noInwardBadge">No Inward</div>
        )}
      </div>

      <div className="cardMenuHeaderText">
        <div className="cardDiateryContainer">
          <PosCustomIcon
            image={foodType === "VEG" ? vegIcon : nonVegIcon}
            height={"16px"}
            width={"16px"}
          />
          <p>{title}</p>
        </div>
        <div className="quickMenuCardKebabWrapper">
          <div className="quickMenuCardKebabIcon" onClick={() => setShowDropdown((prev) => !prev)}>
            <PosCustomIcon
              icon={<EllipsisVerticalIcon />}
              height={"20px"}
              width={"20px"}
              pointer={true}
            />
          </div>
        </div>
        {showDropdown && (
          <div className="quickMenuDropdown">
            <div className="menuDropdownWrapper">
              <p>Status</p>
              <div className="quickMenuDropdownItem">
                <span>{isEnabled ? "Active" : "In Active"}</span>
                <button
                  className={`toggleSwitch ${isEnabled ? "toggleOn" : "toggleOff"}`}
                  onClick={handleToggle}
                >
                  <div className="toggleCircle" />
                </button>
              </div>
              <p className="quickMenuToggleDesc">
                Note: Disabling this will disable the item in all sales channels.
              </p>
            </div>
          </div>
        )}
      </div>

      <div className="QuickMenuCardSecondaryText">
        <div className="QuickMenuCardPriceContainer">
          <p className="QuickMenuCardPrice">{`${getStoreCurrencySymbol()}${price}`}</p>
          <p className="QuickMenuCardShortcode">{`[${shortCode}]`}</p>
        </div>
        <PosCustomButton
          title="Edit"
          variant="blue-d"
          radius="4px"
          p={"6px 10px"}
          fontSize="0.813rem"
          iconOnLeft={
            <PosCustomIcon
              icon={<PencilSquareIcon />}
              height={"18px"}
              width={"18px"}
              color="var(--surface-white)"
            />
          }
          onClickFunction={onEdit}
        />
      </div>
      <Dialog open={showDisableModal} onClose={() => setShowDisableModal(false)}>
        <DialogTitle>Disable Product</DialogTitle>
        <DialogContent>
          <p>Are you sure you want to disable "{title}"?</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowDisableModal(false)}>Cancel</Button>
          <Button onClick={handleConfirmDisable} variant="contained" color="error">
            Disable
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default QuickMenuCard;
